
import { api_host, api_auth} from '../../common/globals/constants';


export const getLastAvailabilityStep = (objetivo_id, id_user, token) => fetch(api_host+`/reporte/online/indicadores/StepsLastAvailabilityObjetive/?user=${id_user}&objetivoId=${objetivo_id}&token=${token}`)
.then(response => response.json())
